import _classCallCheck from "C:\\Repos\\dotnet-factory.com\\trydo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Repos\\dotnet-factory.com\\trydo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import { OptionsColor } from "../../OptionsColor";
export var Trail = /*#__PURE__*/function () {
  function Trail() {
    _classCallCheck(this, Trail);
    this.enable = false;
    this.length = 10;
    this.fillColor = new OptionsColor();
    this.fillColor.value = "#000000";
  }
  _createClass(Trail, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }
      if (data.enable !== undefined) {
        this.enable = data.enable;
      }
      this.fillColor = OptionsColor.create(this.fillColor, data.fillColor);
      if (data.length !== undefined) {
        this.length = data.length;
      }
    }
  }]);
  return Trail;
}();